import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moreSelections: {
		id: 'work-management-board.board.column.card.card-badge.more-selections',
		defaultMessage: ' + {count, plural, one {# other} other {# others}}',
		description: 'Message to show how many other people are selecting the same node',
	},
});
